import { StatesModule, Transition } from '@uirouter/angular';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { ChecklistTemplateListViewComponent } from '@fi-app/checklist-template/checklist-template-list-view/checklist-template-list-view.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiChecklistEditComponent } from '@fi-app/checklist/edit/edit.component';
import { ChecklistModel } from '@fi-app/checklist/checklist.model';
import { ChecklistService } from '@fi-app/checklist/checklist.service';
import { FiChecklistTemplateViewComponent } from '@fi-app/checklist-template/checklist-template-view/checklist-template-view.component';
import { LoadingService } from '@fi-app/shared/fi-loading/loading.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';

const ChecklistListTemplateState: Ng2StateDeclaration = {
    name: FiStateNames.Checklist.Template._name,
    url: '/Template',
    abstract: true,
    component: FiAbstractStateComponent,
};

const ChecklistListTemplateListState: Ng2StateDeclaration = {
    name: FiStateNames.Checklist.Template.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:offset',
    component: ChecklistTemplateListViewComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, ChecklistListTemplateList_pageTitle],
    },
};
export function ChecklistListTemplateList_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleByItem(ObjectTypes.CheckListTemplate);
}

const ChecklistAddTemplateState: Ng2StateDeclaration = {
    name: FiStateNames.Checklist.Template.Add,
    url: '/Add',
    views: {
        '@Module': {
            component: FiChecklistEditComponent,
        },
    },
    resolve: {
        pageTitle: [PageTitleService, 'checklist', ChecklistAddTemplate_pageTitle],
        checklist: [ChecklistService, ChecklistAddTemplate_checklist],
    },
};
export function ChecklistAddTemplate_pageTitle(ccmPageTitle: PageTitleService, checklist: ChecklistModel) {
    return ccmPageTitle.setTitleByItem(checklist);
}
export function ChecklistAddTemplate_checklist(checklistService: ChecklistService) {
    return checklistService.getChecklistInstance({ IsTemplate: true, CheckPoints: [{}] });
}

const ChecklistTemplateViewState: Ng2StateDeclaration = {
    name: FiStateNames.Checklist.Template.View,
    url: '/{Id:[0-9]+}',
    views: {
        '@Module': {
            component: FiChecklistTemplateViewComponent,
        },
    },
    resolve: {
        checklist: [FiStateService, '$transition$', ChecklistService, LoadingService, ChecklistTemplateView_checklist],
        pageTitle: [PageTitleService, 'checklist', ChecklistTemplateView_pageTitle],
    },
};
export function ChecklistTemplateView_checklist(
    stateService: FiStateService,
    transition: Transition,
    checklistService: ChecklistService,
    fiLoadingService: LoadingService,
) {
    return fiLoadingService.trackPromise(checklistService.getCheckListTemplate(stateService.getParams(transition).Id));
}
export function ChecklistTemplateView_pageTitle(ccmPageTitle: PageTitleService, checklist: ChecklistModel) {
    return ccmPageTitle.setTitleByItem(checklist);
}

const ChecklistEditTemplateState: Ng2StateDeclaration = {
    name: FiStateNames.Checklist.Template.Edit,
    url: '/{Id:[0-9]+}/Edit',
    views: {
        '@Module': {
            component: FiChecklistEditComponent,
        },
    },
    resolve: {
        checklist: [FiStateService, Transition, ChecklistService, LoadingService, ChecklistTemplateView_checklist],
        pageTitle: [PageTitleService, 'checklist', ChecklistEditTemplate_pageTitle],
    },
};
export function ChecklistEditTemplate_pageTitle(ccmPageTitle: PageTitleService, checklist: ChecklistModel) {
    return ccmPageTitle.setTitleByItem(checklist);
}

export const ChecklistTemplateStates: StatesModule = {
    states: [
        ChecklistListTemplateState,
        ChecklistListTemplateListState,
        ChecklistAddTemplateState,
        ChecklistTemplateViewState,
        ChecklistEditTemplateState,
    ],
};
